// Role-based access control config.
// allowedRoutes = null means unrestricted (full access).
export const ROLE_ROUTES = {
  master: null, // full access
  master2: null, // full access, tetapi READ-ONLY (lihat isReadOnly)
  admin_pusat: ['/transactions', '/hutang-piutang', '/mitra', '/branches', '/investments', '/peta'],
  admin_transaksi_kas_cabang: ['/transactions', '/hutang-piutang'],
  admin_kas_cabang: ['/hutang-piutang'],
  // legacy roles keep their previous (unrestricted) behavior
  admin_cabang: null,
  investor: null,
};

export const ROLE_LABELS = {
  master: 'Master',
  master2: 'Master 2',
  admin_pusat: 'Admin Pusat',
  admin_transaksi_kas_cabang: 'Admin Transaksi & Kas Cabang',
  admin_kas_cabang: 'Admin Kas Cabang',
  admin_cabang: 'Admin Cabang',
  investor: 'Investor',
};

// Roles selectable when creating/editing a user
export const SELECTABLE_ROLES = [
  'master',
  'master2',
  'admin_pusat',
  'admin_transaksi_kas_cabang',
  'admin_kas_cabang',
];

// Fixed, read-only descriptions per role
export const ROLE_DESCRIPTIONS = {
  master: 'Dapat Mengakses Segala Menu',
  master2: 'Dapat Mengakses Segala Menu, tetapi hanya melihat (tidak dapat menambah, mengubah, atau menghapus)',
  admin_pusat: 'Dapat Mengakses Menu Transaksi, Hutang Piutang, Mitra, Cabang, Investasi dan Peta',
  admin_transaksi_kas_cabang: 'Dapat mengakses menu Transaksi dan Hutang Piutang (hanya menampilkan tabel Saldo Rekening Cabang dan Laba Rugi Mitra)',
  admin_kas_cabang: 'Dapat mengakses menu Hutang Piutang (hanya menampilkan saldo Rekening Cabang)',
  investor: 'Akses portal investor',
};

// ---------------------------------------------------------------------------
// Capability helpers — SINGLE SOURCE OF TRUTH for role checks.
// Always use these instead of inline role comparisons so adding/renaming a
// role only requires editing this file (prevents stale-guard bugs).
// Each accepts either a user object ({ role }) or a raw role string.
// ---------------------------------------------------------------------------
const roleOf = (userOrRole) => {
  if (!userOrRole) return '';
  const r = typeof userOrRole === 'string' ? userOrRole : userOrRole.role;
  return (r || '').toLowerCase();
};

// Full, unrestricted access to everything.
export const isMaster = (userOrRole) => roleOf(userOrRole) === 'master';

// Master 2: boleh membuka semua halaman tetapi tidak boleh menulis apa pun.
// Dipakai sebagai satu-satunya sumber kebenaran untuk menyembunyikan tombol aksi.
export const isReadOnly = (userOrRole) => roleOf(userOrRole) === 'master2';

// Flag global supaya komponen Button bisa menyembunyikan tombol aksi tanpa
// harus mengubah puluhan halaman satu per satu.
let readOnlyMode = false;
export const setReadOnlyMode = (value) => {
  readOnlyMode = !!value;
};
export const getReadOnlyMode = () => readOnlyMode;

// Can manage finance/operational entities: Cabang, Mitra, Investor,
// Investasi, Periode (add/edit/delete/transfer). Master + Admin Pusat.
export const canManageFinance = (userOrRole) =>
  ['master', 'admin_pusat'].includes(roleOf(userOrRole));

export const getAllowedRoutes = (role) => {
  if (!role) return null;
  return role in ROLE_ROUTES ? ROLE_ROUTES[role] : null;
};

export const isRouteAllowed = (role, path) => {
  const allowed = getAllowedRoutes(role);
  if (allowed === null) return true; // unrestricted
  // Normalize: match by prefix segment
  return allowed.some((p) => path === p || path.startsWith(p + '/'));
};

export const getDefaultRoute = (role) => {
  const allowed = getAllowedRoutes(role);
  if (allowed === null) return '/';
  if (allowed.includes('/transactions')) return '/transactions';
  return allowed[0] || '/';
};

// Hutang Piutang table visibility per role.
// Returns { tables: [...], showTransfer: bool }. tables=null means all tables.
export const getHutangPiutangAccess = (role) => {
  if (role === 'admin_transaksi_kas_cabang') {
    return { tables: ['branch', 'manager'], showTransfer: false };
  }
  if (role === 'admin_kas_cabang') {
    return { tables: ['branch'], showTransfer: false };
  }
  return { tables: null, showTransfer: true };
};
